import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from '../../utils/axiosInterceptor';

import {
    Box, Divider, Typography, Grid, Button, Container, Fab, FormControl, TextField, Autocomplete, Paper,
    InputLabel, Select, MenuItem
} from '@mui/material';

import CustomMessage from '../../utils/components/CustomMessage';
import CustomChip from '../../utils/components/CustomChip';
import { formatMoney } from '../../utils/functions/Utils';

function AgregarProducto() {

    let navigate = useNavigate();
    const auth = useSelector((state) => state.auth);

    const [nombre, setNombre] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [clave, setClave] = useState('');

    const [costoUnitario, setCostoUnitario] = useState('');
    const [precioUnitario, setPrecioUnitario] = useState('');
    const [precioDistribuidor, setPrecioDistribuidor] = useState(0);
    const [cantidad, setCantidad] = useState(0);
    const [proveedor, setProveedor] = useState('');
    const [imagen, setImagen] = useState('');
    const [stockMinimo, setStockMinimo] = useState(0);
    const [stockMaximo, setStockMaximo] = useState(0);
    const [notaDeStock, setNotaDeStock] = useState('');
    const [ubicacion, setUbicacion] = useState({ almacen: '', anaquel: '', nivel: '', posicion: '' });
    const [noSerie, setNoSerie] = useState('');
    const [noInventario, setNoInventario] = useState('');
    const [observaciones, setObservaciones] = useState('');
    const [unidad, setUnidad] = useState('');
    const [marca, setMarca] = useState('');
    const [modelo, setModelo] = useState('');
    const [caducidad, setCaducidad] = useState('');
    // const [productoCronos, setProductoCronos] = useState({});
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [proveedores, setProveedores] = useState([
        { id: 1, nombre: 'Cliente 1' },
        { id: 2, nombre: 'Cliente 2' },
        { id: 3, nombre: 'Cliente 3' },
        { id: 4, nombre: 'Cliente 4' },
        { id: 5, nombre: 'Cliente 5' },
    ]);

    const [categoria, setCategoria] = useState('');
    const [categories, setCategories] = useState([{}]);

    const [almacen, setAlmacen] = useState('');
    const [almacenes, setAlmacenes] = useState([{}]);

    const [largo, setLargo] = useState('');
    const [ancho, setAncho] = useState('');
    const [alto, setAlto] = useState('');

    const [apiRes, setApiRes] = useState({ show: false, message: '', severity: '' });

    useEffect(() => {
        if (!['Admin', 'Almacen'].includes(auth.user.rol)) {
            navigate('/dashboard');
        }
        document.title = 'Agregar producto';
    }, [auth])

    const handleCloseMessage = (show) => {
        setApiRes(state => { return { ...state, show: show } })
    }

    useEffect(() => {
        getData();
    }, [])

    const getData = async () => {
        try {
            let res = await axios.get('/api/suppliers/');
            if (res.status === 200) {
                setProveedores(res.data);
            }
            res = await axios.get(`/api/configs/company/${auth.user.company}`);
            if (res.status === 200) {
                setCategories(res.data.categorias);
            }
            res = await axios.get('/api/warehouses');
            if (res.status === 200) {
                setAlmacenes(res.data);
            }
        } catch (err) {
            console.log(err);
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setButtonDisabled(true);
        const product = {
            nombre: nombre,
            descripcion: descripcion,
            clave: clave,
            categoria: categoria,
            costoUnitario: isNaN(Number(costoUnitario)) ? 0 : Number(costoUnitario),
            precioUnitario: isNaN(Number(precioUnitario)) ? 0 : Number(precioUnitario),
            precioDistribuidor: isNaN(Number(precioDistribuidor)) ? 0 : Number(precioDistribuidor),
            cantidad: cantidad,
            proveedor: proveedor,
            imagen: imagen.replace('https://drive.google.com/file/d/', 'https://drive.google.com/uc?export=view&id=').replace('/view?usp=drive_link', ''),
            stockMinimo: stockMinimo === '' ? '' : Number(stockMinimo),
            stockMaximo: stockMaximo === '' ? '' : Number(stockMaximo),
            notaDeStock: notaDeStock,
            ubicacion: {
                almacen: almacen,
                anaquel: ubicacion.anaquel,
                nivel: ubicacion.nivel,
                posicion: ubicacion.posicion,
            },
            noSerie: noSerie,
            noInventario: noInventario,
            observaciones: observaciones,
            unidad: unidad,
            marca: marca,
            modelo: modelo,
            caducidad: '',
            largo: largo,
            ancho: ancho,
            alto: alto,
        };

        try {
            const res = await axios.post('/api/products/', { product: product });
            if (res.status === 200) {
                setApiRes(state => { return { ...state, show: true, message: 'El producto fue creado con exito', severity: 'success' } });
                setTimeout(() => {
                    navigate('/inventario');
                }, 800);
            }
        } catch (err) {
            setApiRes(state => { return { ...state, show: true, message: 'Ocurrió un error al crear el producto, favor de intentarlo mas tarde', severity: 'error' } });
            setButtonDisabled(false);
            console.log(err);
        }
    }

    useEffect(() => {
        setPrecioDistribuidor(Number(precioUnitario) / 1.2)
    }, [precioUnitario])

    return (
        <Container maxWidth='xxl' style={{ marginTop: '10px' }}>
            <Paper sx={{ padding: '24px 0px' }} elevation={3}>
                <Container maxWidth='xl'>
                    <Box className='text-center' >
                        <Typography variant='h5' style={{ fontWeight: 700 }}>Agregar Producto</Typography>
                    </Box>

                    <Button size='small' variant='outlined' onClick={() => navigate('/inventario')}><i className='fad fa-arrow-left'></i> &nbsp;&nbsp;Regresar</Button>

                    <Divider className='my-3' textAlign="left">
                        <CustomChip variant='outlined' estatus='AUTORIZADO' label='Detalles del producto' className='text-bold' />
                    </Divider>

                    <form onSubmit={(e) => handleSubmit(e)}>
                        <Fab aria-label="add" type='submit' color='success' disabled={buttonDisabled} style={{ position: 'fixed', top: '70px', left: '24px', zIndex: '10', opacity: '60%' }}>
                            <i className="fad fa-save fa-2x"></i>
                        </Fab>

                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <FormControl required sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="Producto" variant="outlined" multiline={true} value={nombre} onChange={(e) => setNombre(e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="Descripción" variant="outlined" multiline={true} value={descripcion} onChange={(e) => setDescripcion(e.target.value)} />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="Clave del Producto" variant="outlined" value={clave} onChange={(e) => setClave(e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl required sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <Autocomplete
                                        disablePortal
                                        freeSolo={true}
                                        onInputChange={(event, newInputValue) => setCategoria(newInputValue)}
                                        inputValue={categoria}
                                        aria-multiline='true'
                                        options={categories.map((option) => option.nombre)}
                                        renderInput={(params) => <TextField {...params} label='Categoría' helperText='Seleccione una categoría de la lista.' />}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField error={isNaN(Number(costoUnitario)) ? true : false} helperText={isNaN(Number(costoUnitario)) ? 'El costo debe ser un número' : `$ ${formatMoney(costoUnitario)}`} label="Costo unitario" variant="outlined" value={costoUnitario} onChange={(e) => setCostoUnitario(e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField error={isNaN(Number(precioUnitario)) ? true : false} helperText={isNaN(Number(precioUnitario)) ? 'El precio debe ser un número' : `$ ${formatMoney(precioUnitario)}`} label="Precio unitario" variant="outlined" value={precioUnitario} onChange={(e) => setPrecioUnitario(e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField error={isNaN(Number(precioDistribuidor)) ? true : false} helperText={isNaN(Number(precioDistribuidor)) ? 'El precio debe ser un número' : `$ ${formatMoney(precioDistribuidor)}`} label="Precio a distribuidor (antes de IVA)" variant="outlined" value={precioDistribuidor} onChange={(e) => setPrecioDistribuidor(e.target.value)} />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField disabled label="Cantidad" variant="outlined" value={cantidad} onChange={(e) => setCantidad(Number(e.target.value))} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl required sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <Autocomplete
                                        disablePortal
                                        freeSolo={true}
                                        onInputChange={(event, newInputValue) => setProveedor(newInputValue)}
                                        inputValue={proveedor}
                                        aria-multiline='true'
                                        options={proveedores.map((option) => option.name)}
                                        renderInput={(params) => <TextField {...params} label='Proveedor' />}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="Imagen" variant="outlined" value={imagen} onChange={(e) => setImagen(e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="Stock minimo" variant="outlined" value={stockMinimo} onChange={(e) => setStockMinimo(e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="Stock maximo" variant="outlined" value={stockMaximo} onChange={(e) => setStockMaximo(e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="Nota de Stock" variant="outlined" value={notaDeStock} onChange={(e) => setNotaDeStock(e.target.value)} />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Divider className='my-3' textAlign="left">
                            <CustomChip variant='outlined' estatus='AUTORIZADO' label='Ubicacion de almacén' className='text-bold' />
                        </Divider>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={3}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <InputLabel id="select">Almacén</InputLabel>
                                    <Select
                                        labelId="select"
                                        value={almacen}
                                        label="Almacén"
                                        onChange={(e) => setAlmacen(e.target.value)}
                                    >
                                        {almacenes.map((x, i) => (
                                            <MenuItem key={i} value={x.almacen}>{x.almacen}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="Anaquel" variant="outlined" value={ubicacion.anaquel} onChange={(e) => setUbicacion({ ...ubicacion, anaquel: e.target.value })} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="Nivel" variant="outlined" value={ubicacion.nivel} onChange={(e) => setUbicacion({ ...ubicacion, nivel: e.target.value })} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="Posición" variant="outlined" value={ubicacion.posicion} onChange={(e) => setUbicacion({ ...ubicacion, posicion: e.target.value })} />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Divider className='my-3' textAlign="left">
                            <CustomChip variant='outlined' estatus='AUTORIZADO' label='Dimensiones del producto' className='text-bold' />
                        </Divider>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={4}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="Largo (x)" variant="outlined" value={largo} onChange={(e) => setLargo(e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="Ancho (y)" variant="outlined" value={ancho} onChange={(e) => setAncho(e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="Alto (z)" variant="outlined" value={alto} onChange={(e) => setAlto(e.target.value)} />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Divider className='my-3' textAlign="left">
                            <CustomChip variant='outlined' estatus='AUTORIZADO' label='Caracteristicas del producto' className='text-bold' />
                        </Divider>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="Marca" variant="outlined" value={marca} onChange={(e) => setMarca(e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="Modelo" variant="outlined" value={modelo} onChange={(e) => setModelo(e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="No. de Serie" variant="outlined" value={noSerie} onChange={(e) => setNoSerie(e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="No. de Inventario" variant="outlined" value={noInventario} onChange={(e) => setNoInventario(e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="Unidad" variant="outlined" value={unidad} onChange={(e) => setUnidad(e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="Caducidad" variant="outlined" value={caducidad} onChange={(e) => setCaducidad(e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="Observaciones" variant="outlined" value={observaciones} multiline={true} onChange={(e) => setObservaciones(e.target.value)} />
                                </FormControl>
                            </Grid>
                        </ Grid>

                        <hr></hr>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <Button disabled={buttonDisabled} className='my-2' variant="contained" size='large' color="success" type='submit'>Guardar &nbsp; <i className="fad fa-save"></i></Button>
                            </Grid>
                        </Grid>
                    </form>
                </Container>
                <CustomMessage open={apiRes.show} message={apiRes.message} severity={apiRes.severity} handleCloseMessage={handleCloseMessage} />
            </Paper>
        </Container>
    );
}

export default AgregarProducto;